import { AutenticacionService } from './../../../services/autenticacion.service';
import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ObrasService} from '../../../services/obras.service';
import {HelpersService} from '../../../services/tools/helpers.service';
import { DomSanitizer } from '@angular/platform-browser';
declare var $;
declare var Dropzone;

@Component({
  selector: 'app-catalogo-obras-fotografia',
  templateUrl: './catalogo-obras-fotografia.component.html',
  styleUrls: ['./catalogo-obras-fotografia.component.scss']
})
export class CatalogoObrasFotografiaComponent implements OnInit {

  @Input() public obraSelected;
  @Output() public savingImagen: EventEmitter<any> = new EventEmitter;

  public localFile: any = {};
  public savedFile: any;
  public dropzone;
  public uploading = false;
  public imageLoading: boolean;
  constructor(  private obrasService: ObrasService,
                private helpers: HelpersService,
                private authService: AutenticacionService,
                private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.initDropzone();
    this.getObraImagenURL();
  }
  ngOnChanges(changes: SimpleChanges) {
    if ( !changes.obraSelected.firstChange ) {
      this.localFile = {};
      this.dropzone.removeAllFiles( true );
      this.dropzone.options.params.id = this.obraSelected.idObras;
      this.getObraImagenURL();
      console.log('changing id obras...', changes);
    }
  }

  getObraImagenURL() {
    if (this.obraSelected.urlImagen) {
      this.imageLoading = true;
      this.obrasService.getImageUrl(this.obraSelected.idObras).subscribe(response => {
        console.log('getImageUrl-response ', response);
        this.localFile = {};
        const unsave_url = window.URL.createObjectURL(response.blob());
        // sanitize the url generatet from the blob;
        this.savedFile = this.sanitizer.bypassSecurityTrustUrl(unsave_url);
        this.imageLoading = false;
      });
    } else {
      this.imageLoading = false;
      this.savedFile = undefined;
    }
  }

  saveImagen() {
    if (this.obraSelected.idObras) {
      this.uploading = true;
      this.dropzone.options.params.id = this.obraSelected.idObras;
      this.dropzone.processQueue();
    } else {
      this.helpers.notification('ALERTA!', 'Es necesario guardar tu cambios de obra para poder agregar imagen.', 'warning');
    }
  }

  writePermission() {
    return this.obrasService.writePermission();
  }

  deleteImagen() {
    if (this.obraSelected.urlImagen) {
      this.obrasService.deleteObraImagen(this.obraSelected.idObras)
          .subscribe((response) => {
            this.savingImagen.emit('');
            this.savedFile = undefined;
            console.log('deleted');
            this.helpers.notification('Imagen eliminada!', 'Se ha eliminado correctamente la imagen de la obra.', 'success');
          }, (error) => {
            // resolviendo errores 403 y 500
            this.helpers.httpGlobalError(error);
            console.log('error delete imagen...', error);
          });
    }
    this.localFile = {};
    this.dropzone.removeAllFiles( true );
  }

  initDropzone() {
    let _this = this;
    // si no existe una sesión debemos matar el usuario y salir
    if (!this.authService.getToken()) {
      this.authService.killUser();
    }
    const token = this.authService.getToken();
    console.log('initDropzone-token ', token);
    this.dropzone = new Dropzone('#catalogo-obra-fotografia', {
      url: this.obrasService.imagen_url,
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Cache-Control': '',
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': 'Bearer ' + token
      },
      paramName: 'imagen',
      params: {
        id: this.obraSelected.idObras
      },
      acceptedFiles: 'image/jgp,image/jpeg,image/png',
      maxFilesize: 2,
      autoProcessQueue: false,
      init: function() {
        this.on('addedfile', function(file) {
          file.previewElement.remove();
          file.previewTemplate.remove();
        });
        this.on('success', function(file, response) {
          _this.helpers.notification('Imagen guardada', 'Se guardó correctamente la imagen de la obra.', 'success');
          _this.savingImagen.emit('imagen');
          _this.obraSelected.urlImagen = 'imagen';
          _this.getObraImagenURL();
          _this.uploading = false;
        });
        this.on('error', function(file, error) {
          _this.uploading = false;
          if (file.size > 2000000) {
            console.log('sending');
            _this.helpers.notification('ERROR!', 'Tamaño máximo de imagen: 2MB.', 'error');
          } else {
            console.log('sending');
            _this.helpers.notification('ERROR!', 'Formato de imagen inválido.', 'error');
          }
        });
        this.on('thumbnail', function(file) {
          if (file.status != 'error') {
            _this.localFile = file;
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-obras/catalogo-obras-fotografia/catalogo-obras-fotografia.component.ts